import { authAxios as axios } from "shared-auth";
import config from "config/global";

export default async function getMySuggestionsCount() {
  const response = await axios(
    `${config.suggestionsApiUrl}/suggestions/count`,
    {}
  );

  return response.data;
}
